<section class="site-info-edit-container">
  <div>
    <div class="title">{{ 'text_editYourSitesStructure' | dbText }}</div>
    <div class="subtitle">{{ 'text_theStructureIsBasedOnYourSiteBrief' | dbText }}</div>
    <div class="site-brief-info">
      <div class="brief-title">{{ 'text_siteBrief' | dbText }}</div>
      <div class="brief-info-items">
        <div class="brief-info-item">
          <div class="label">{{ 'text_websiteName' | dbText }}</div>
          <div class="brief-info-value">
            @if (isEditName) {
              <input [class.invalid]="titleForm.invalid" [formControl]="titleForm" [value]="builderInteractionsService.siteInfo.value?.business_name"
              class="edit-business-name-input" #title (blur)="saveEdited(title.value)">
            } @else {
              <div class="simple-text editable capitalize">
                <i class="db-icon db-icon-ds-edit-website" (click)="onEdit(builderInteractionsService.siteInfo.value?.business_name)"></i>
               <span (click)="onEdit(builderInteractionsService.siteInfo.value?.business_name)">{{ builderInteractionsService.siteInfo.value?.business_name }}</span>
              </div>
            }
          </div>
        </div>
        <div class="brief-info-item">
          <div class="label">{{ 'text_websiteType' | dbText }}</div>
          <div class="brief-info-value">
            <div class="simple-text">
              {{ builderInteractionsService.siteInfo.value?.website_type === 'basic' ? ('text_informational' | dbText) : "Ecommerce"}}
            </div>
          </div>
        </div>
        <div class="brief-info-item">
          <div class="label">{{ 'text_industry' | dbText }}</div>
          <div class="brief-info-value">
            <div class="simple-text capitalize">
              {{ builderInteractionsService.siteInfo.value?.business_type }}
            </div>
          </div>
        </div>
        <div class="brief-info-item">
          <div class="label">{{ 'text_numberOfPages' | dbText }}</div>
          <div class="brief-info-value">
            <div class="simple-text">
              {{ (builderInteractionsService.secondaryPages|async)?.length  + 1}} {{ ((builderInteractionsService.secondaryPages|async)?.length  + 1) > 1 ? 'pages' : 'page' }}
            </div>
          </div>
        </div>
      </div>
    </div>
      @if (commonDataService.builderType !== 'section_based') {
          <div class="site-description-container">
              <div class="desc-title">{{ 'text_enhancedSiteDescription' | dbText }}</div>
              <div class="description">{{ builderInteractionsService.siteInfo.value?.business_description }}</div>
              <span class="show-more-btn" (click)="openDescription.emit()">{{ 'text_showMore' | dbText }}</span>
          </div>
      }
  </div>
  <ng-content></ng-content>
</section>
